import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { isMobile } from "react-device-detect";
import AddToBasketRoundedButton from "../addToBasketRoundedButton";
import { IconBasket1 } from "../../../assets/icons";

function SkeletonDetailsContetnt() {
  return (
    <>
      <Card
        className={`${isMobile ? "p-1" : "p-2"}  rounded-3 text-center mb-5`}
      >
        <Skeleton
          width="100%"
          height={isMobile ? "108px" : "150px"}
          className="rounded-3"
        ></Skeleton>
        <Card.Body className=" pb-0">
          <Skeleton height={isMobile ? "15px" : "20px"}></Skeleton>
        </Card.Body>
        <Card.Footer className="border-top-0 pt-2 bg-white">
          <Row className="">
            <Col xs="12" className="">
              <Skeleton height={isMobile ? "13px" : "18px"}></Skeleton>
            </Col>
            <Col xs="12" className="mt-1">
              <Skeleton
                height={isMobile ? "22px" : "28px"}
                className="rounded-2"
              ></Skeleton>
            </Col>
          </Row>
        </Card.Footer>
      </Card>
    </>
  );
}

export default SkeletonDetailsContetnt;
